import { render, staticRenderFns } from "./oldTransaction.vue?vue&type=template&id=0fe6c8ec&scoped=true&"
import script from "./oldTransaction.vue?vue&type=script&lang=js&"
export * from "./oldTransaction.vue?vue&type=script&lang=js&"
import style0 from "./oldTransaction.vue?vue&type=style&index=0&id=0fe6c8ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6c8ec",
  null
  
)

export default component.exports